module.exports = __webpack_public_path__ + "img/1.051b84fc.svg";